/**
 * Recently viewed products section (sections/recently-viewed.liquid).
 *
 * Product views are recorded in localStorage by
 * snippets/recently-viewed-tracker.liquid (rendered on product pages). This
 * element fetches its own section through the Section Rendering API with a
 * storefront search for those ids, so the injected cards are rendered
 * server-side by the exact same card-product snippet and settings as the rest
 * of the theme. The section stays hidden until at least one product loads.
 */
class RecentlyViewedProducts extends HTMLElement {
  static STORAGE_KEY = 'party-stuff:recently-viewed';

  connectedCallback() {
    this.load();
  }

  readIds() {
    try {
      const ids = JSON.parse(window.localStorage.getItem(RecentlyViewedProducts.STORAGE_KEY) || '[]');
      return Array.isArray(ids) ? ids : [];
    } catch {
      return [];
    }
  }

  async load() {
    // Don't show the product the visitor is currently looking at.
    const currentId = Number(document.querySelector('product-info[data-product-id]')?.dataset.productId);
    const ids = this.readIds()
      .filter((id) => id !== currentId)
      .slice(0, Number(this.dataset.limit) || 4);
    if (!ids.length) return;

    const query = ids.map((id) => `id:${id}`).join(' OR ');
    const url = `${this.dataset.searchUrl}?q=${encodeURIComponent(query)}&type=product&section_id=${this.dataset.sectionId}`;

    try {
      const response = await fetch(url);
      if (!response.ok) return;
      const html = new DOMParser().parseFromString(await response.text(), 'text/html');
      const grid = html.querySelector('[data-recently-viewed-results] ul');
      if (!grid || !grid.querySelector('[data-product-id]')) return;

      // Search returns results in its own order — restore most-recent-first.
      ids.forEach((id) => {
        const item = grid.querySelector(`li[data-product-id="${id}"]`);
        if (item) grid.append(item);
      });

      this.querySelector('[data-recently-viewed-slot]').replaceChildren(grid);
      this.hidden = false;
    } catch {
      // Network hiccup — the section simply stays hidden.
    }
  }
}

customElements.define('recently-viewed-products', RecentlyViewedProducts);
